import { Heart, Leaf, Zap, Activity, Droplets, Scale, TrendingDown } from 'lucide-react';
import { AnimatedSection } from '@/hooks/useScrollAnimation';

const differentials = [
  {
    id: 1,
    icon: Droplets,
    title: 'Soroterapia',
    description: 'Reposição nutricional injetável para Vitaminas, Minerais e Aminoácidos.',
    link: '/soroterapia',
  },
  {
    id: 2,
    icon: Zap,
    title: 'Energia e Foco',
    description: 'Tratamento para fadiga crônica e exaustão com medicina integrativa.',
    link: '/energia-e-foco',
  },
  {
    id: 3,
    icon: Activity,
    title: 'Fibromialgia e Artrite',
    description: 'Tratamento integrativo para dor crônica e inflamação.',
    link: '/fibromialgia-e-artrite',
  },
  {
    id: 4,
    icon: Scale,
    title: 'Pós-Bariátrica',
    description: 'Reposição de micronutrientes e manutenção de peso sustentável.',
    link: '/pos-bariatrica',
  },
  {
    id: 5,
    icon: TrendingDown,
    title: 'Emagreça+',
    description: 'Emagrecimento com acompanhamento médico, tratando as causas do efeito sanfona.',
    link: '/emagreca-mais',
  },
  {
    id: 6,
    icon: Heart,
    title: 'Medicina Personalizada',
    description: 'Tratamentos individualizados para suas necessidades específicas.',
  },
];

const Differentials = () => {
  return (
    <AnimatedSection className="section-padding" id="diferenciais">
      <div className="container-mobile">
        {/* Header */}
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            Diferenciais
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-semibold text-foreground mb-3">
            Por que escolher a Habitus?
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Combinamos medicina convencional e abordagens integrativas com respaldo científico.
          </p>
        </div>

        {/* Differentials List - Stack on mobile, grid on desktop */}
        <div className="space-y-4 md:space-y-0 md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-6">
          {differentials.map((item, index) => {
            const CardContent = (
              <div className="flex items-start gap-4">
                {/* Icon */}
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                  <item.icon className="w-6 h-6 text-primary" />
                </div>

                {/* Content */}
                <div>
                  <h3 className="font-serif text-lg font-semibold text-foreground mb-1">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            );

            if (item.link) {
              return (
                <a
                  key={item.id}
                  href={item.link}
                  className="group block p-6 rounded-2xl bg-card border border-border hover:border-primary/30 hover:shadow-lg transition-all"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  {CardContent}
                </a>
              );
            }

            return (
              <div
                key={item.id}
                className="group p-6 rounded-2xl bg-card border border-border hover:border-primary/30 hover:shadow-lg transition-all"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {CardContent}
              </div>
            );
          })}
        </div>
      </div>
    </AnimatedSection>
  );
};

export default Differentials;
